import { put, call, takeEvery, select } from 'redux-saga/effects';

import checkoutAPI from '../../api/checkout';
import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* customerOrderPaymentRequest({ order }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const payment = yield call(customerAPI.orderInformations, order.hash, 'pagamento', token, siteId);

    const billetPayment = payment.find((item) => item.formaPagamento === 'BA');
    const cardPayment = payment.find((item) => item.formaPagamento === 'CC');
    const financialPayment = payment.find((item) => item.formaPagamento === 'FI');
    const depositPayment = payment.find((item) => item.formaPagamento === 'DP');

    const paymentLoaded = { payment, id: order.id, paymentError: false };

    if (order.idStatus === 17) {
      if (billetPayment) {
        try {
          const billet = yield call(checkoutAPI.createBillet, siteId, order.hash);
          paymentLoaded.billet = billet;
        } catch (error) {
          paymentLoaded.billetError = error;
        }
      }

      if (cardPayment) {
        paymentLoaded.creditCard = true;
      }

      if (financialPayment) {
        paymentLoaded.financial = true;
      }

      if (depositPayment) {
        try {
          const depositAccounts = yield call(checkoutAPI.depositAccounts, depositPayment.empresa.id, token, siteId);

          paymentLoaded.depositAccounts = depositAccounts;
        } catch (error) {
          paymentLoaded.depositError = error;
        }
      }
    }

    yield put(Creators.customerOrderPaymentSuccess([paymentLoaded], order.id));
  } catch (error) {
    yield put(Creators.customerOrderPaymentFailed([{ id: order.id, paymentError: true }], order.id));
  }
}

export default function* watch() {
  yield takeEvery(Types.CUSTOMER_ORDER_PAYMENT_REQUEST, customerOrderPaymentRequest);
}
